module.exports = __webpack_public_path__ + "static2024-7-11/img/bg_check.494c1ba6.png";